<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>质控因子分类</template>

  <template #body>
    <ul class="qc-device-select-wrapper">
      <li
        v-for="qcDeviceConfig in qcDeviceConfigs"
        :key="qcDeviceConfig.value"
        class="qc-device-select-item"
      >
        <el-checkbox v-model="model" :label="qcDeviceConfig.value">{{qcDeviceConfig.label}}</el-checkbox>
      </li>
    </ul>
  </template>

  <template #footer>
    <el-button type="orange" class="btn save-btn" @click="onSaveBtnClick">保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import qcDeviceConfig from '../../../utils/qcDeviceConfig'

export default {
  name: 'QCFactorCategoryEditor',
  extends: BaseEditor,
  computed: {
    apiKey () {
      return 'QCFactorCategory'
    },
    qcDeviceConfigs: () => qcDeviceConfig.list
  },
  methods: {
    initModel () {
      return []
    },
    onOpen (model) {
      this.siteId = model.id
    },
    onSaveBtnClick () {
      this.changeLoadStatus(true)
      this.$api.QCFactorCategory.save(this.siteId, {
        ids: this.model
      }).then(() => {
        this.close()
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.qc-device-select-wrapper {
  margin: 0;
  padding: 0;

  .qc-device-select-item {
    padding: 0;

    > .el-checkbox {
      display: block;
      padding: 3px 10px;

      &:hover {
        background-color: #f5f7fa;
      }

      /deep/ {
        > * {
          vertical-align: middle;
        }

        .el-checkbox__input {
          height: 14px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/01Site/QCFactorCategoryEditor.vue